import {
	useInnerBlocksProps,
	useBlockProps,
	InnerBlocks,
	BlockControls,
} from '@wordpress/block-editor';
import ProductPageToolbar from './patterns-toolbar';

export default function LayoutContent( {
	name,
	clientId,
	openPatternSelectionModal,
} ) {
	const blockProps = useBlockProps( {
		className: 'sc-product-page__editor-container',
	} );

	const innerBlocksProps = useInnerBlocksProps( blockProps, {
		renderAppender: InnerBlocks.ButtonBlockAppender,
	} );

	return (
		<>
			<BlockControls>
				<ProductPageToolbar
					name={ name }
					clientId={ clientId }
					openPatternSelectionModal={ openPatternSelectionModal }
				/>
			</BlockControls>
			<div { ...innerBlocksProps } />
		</>
	);
}
